/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Unstarred_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Record unstarred successfully" |
*
* @param {Explorer_Info_Unstarred_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_unstarred_success_toast = /** @type {((inputs?: Explorer_Info_Unstarred_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Unstarred_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement retire des favoris")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datensatz erfolgreich entsterned")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registrazione senza stella riuscita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запись успешно не отмечена звездочкой.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El registro no se ha marcado con éxito")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("成功记录未加星标")
	if (locale === "ja") return /** @type {LocalizedString} */ ("レコードのスターを解除しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बिना तारांकित रिकॉर्ड सफलतापूर्वक दर्ज किया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Registro sem estrelas com sucesso")
	return /** @type {LocalizedString} */ ("Record unstarred successfully")
});